import { render, staticRenderFns } from "./MitgliederDetail.vue?vue&type=template&id=6fcc910a&"
import script from "./MitgliederDetail.vue?vue&type=script&lang=js&"
export * from "./MitgliederDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports